export const isEnter = (e: React.KeyboardEvent): boolean => e && (e.key === 'Enter' || e.keyCode === 13) // NOSONAR
